import { useMemo } from 'react'
import type { JSX } from 'react'

import { formatDistance } from 'date-fns'

import { Flex, Text } from '@buffer-mono/popcorn'

import { RefreshButton } from '../ListHeader/RefreshButton'

import styles from './RefreshAction.module.css'

type RefreshActionProps = {
  lastUpdated: string | Date | null
  onRefresh: () => Promise<void>
}

export const RefreshAction = ({
  lastUpdated,
  onRefresh,
}: RefreshActionProps): JSX.Element => {
  const timeAgoStr = useMemo(() => {
    if (!lastUpdated) {
      return undefined
    }
    return formatDistance(new Date(lastUpdated), new Date(), {
      addSuffix: true,
    })
  }, [lastUpdated])

  const timeAgoSentence = useMemo(() => {
    if (timeAgoStr) {
      return `Last refreshed ${timeAgoStr}`
    }
    return 'Not yet refreshed'
  }, [timeAgoStr])

  return (
    <Flex align="center" gap="2xs" className={styles.container}>
      <Text color="subtle" className={styles.text}>
        {timeAgoSentence}
      </Text>
      <RefreshButton refresh={onRefresh} />
    </Flex>
  )
}
